import React, { useState, useEffect } from "react";
import styles from "./QrCodeGenerator.module.css";
import whatsappLogo from "./img/whatsapp.png";

const QrCodeGenerator = () => {

    useEffect(() => {
        document.title = "Gerador de QR Code Online Grátis | WhatsApp, Links e Personalização - Fohattech";
    }, []);

    const [mode, setMode] = useState("text");
    const [text, setText] = useState("");
    const [ddi, setDdi] = useState("55");
    const [phone, setPhone] = useState("");

    const [color, setColor] = useState("#000000");
    const [bgColor, setBgColor] = useState("#ffffff");
    const [size, setSize] = useState(300);

    const [logo, setLogo] = useState(null);
    const [logoName, setLogoName] = useState("");

    useEffect(() => {
        fetch("https://ipwho.is/")
            .then(res => res.json())
            .then(data => {
                if (data && data.calling_code) {
                    setDdi(data.calling_code);
                }
            })
            .catch(() => setDdi("55"));
    }, []);

    const generateQr = async () => {
        const canvas = document.getElementById("qrCanvas");
        const ctx = canvas.getContext("2d");

        let finalText = text;

        if (mode === "whatsapp") {
            if (!phone) return;
            finalText = `https://wa.me/${ddi}${phone}`;
        }

        if (!finalText) return;

        await window.QRCode.toCanvas(canvas, finalText, {
            width: size,
            margin: 3,
            errorCorrectionLevel: "H",
            color: {
                dark: color,
                light: bgColor,
            },
        });

        let imgSrc = null;

        if (mode === "whatsapp") {
            imgSrc = whatsappLogo;
        } else if (logo) {
            imgSrc = logo;
        }

        if (!imgSrc) return;

        const img = new Image();
        img.src = imgSrc;

        img.onload = () => {
            const logoSize = size * 0.18;
            const x = (canvas.width - logoSize) / 2;
            const y = (canvas.height - logoSize) / 2;

            const padding = 3;

            ctx.fillStyle = bgColor;
            ctx.fillRect(
                x - padding,
                y - padding,
                logoSize + padding * 2,
                logoSize + padding * 2
            );

            ctx.drawImage(img, x, y, logoSize, logoSize);
        };
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogo(URL.createObjectURL(file));
            setLogoName(file.name);
        }
    };

    const downloadPNG = () => {
        const canvas = document.getElementById("qrCanvas");
        const link = document.createElement("a");
        link.download = "qrcode.png";
        link.href = canvas.toDataURL();
        link.click();
    };

    const downloadPDF = () => {
        const canvas = document.getElementById("qrCanvas");
        const imgData = canvas.toDataURL("image/png");

        const pdf = new window.jspdf.jsPDF();
        pdf.text("QR Code Gerado", 10, 10);
        pdf.addImage(imgData, "PNG", 15, 20, 180, 180);
        pdf.save("qrcode.pdf");
    };

    return (
        <div className={styles.container}>

            <h2 className={styles.title}>Gerador de QR Code Online Grátis</h2>
            <p className={styles.subtitle}>
                Crie QR Codes personalizados para links, WhatsApp, redes sociais ou qualquer texto.
                Ferramenta gratuita, rápida e totalmente online.
            </p>

            <div className={styles.infoBox}>
                <h3>O que é um QR Code?</h3>
                <p>
                    O QR Code (Quick Response Code) é um tipo de código de barras bidimensional que pode ser escaneado por celulares
                    e dispositivos móveis. Ele permite acessar rapidamente links, contatos, mensagens ou qualquer tipo de informação digital.
                </p>

                <h3>Para que serve?</h3>
                <p>
                    Você pode usar QR Codes para divulgar sites, compartilhar contatos, facilitar pagamentos,
                    enviar mensagens no WhatsApp, divulgar redes sociais ou até mesmo conectar usuários a conteúdos exclusivos.
                </p>

                <h3>QR Code com logo é seguro?</h3>
                <p>
                    Sim! Nossa ferramenta utiliza correção de erro avançada (nível alto), permitindo adicionar um logo no centro
                    sem comprometer a leitura. Isso deixa seu QR Code mais profissional e personalizado.
                </p>
            </div>

            <div className={styles.toolBox}>

                <div className={styles.modeSelector}>
                    <button onClick={() => setMode("text")}>Texto / Link</button>
                    <button onClick={() => setMode("whatsapp")}>WhatsApp</button>
                </div>

                {mode === "text" ? (
                    <input
                        className={styles.input}
                        type="text"
                        placeholder="Digite um link, texto ou URL..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                ) : (
                    <div className={styles.whatsappBox}>
                        <input
                            type="text"
                            value={ddi}
                            onChange={(e) => setDdi(e.target.value)}
                            className={styles.ddi}
                        />
                        <input
                            type="text"
                            placeholder="Número (sem espaços)"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className={styles.phone}
                        />
                    </div>
                )}

                {mode === "text" && (
                    <label className={`${styles.uploadLabel} ${logoName ? styles.hasFile : ""}`}>
                        
                        <span className={styles.uploadText}>
                            {logoName ? "Logo adicionada" : "Adicionar logo"}
                        </span>

                        <span className={styles.uploadStatus}>
                            {logoName ? `✔ ${logoName}` : "Nenhum arquivo selecionado"}
                        </span>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleLogoUpload}
                            className={styles.fileInput}
                        />
                    </label>
                )}

                <div className={styles.options}>
                    <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
                    <input type="color" value={bgColor} onChange={(e) => setBgColor(e.target.value)} />
                </div>

                <button className={styles.button} onClick={generateQr}>
                    Gerar QR Code
                </button>
            </div>

            <div className={styles.result}>
                <canvas id="qrCanvas"></canvas>

                <div className={styles.downloadButtons}>
                    <button onClick={downloadPNG}>Baixar em PNG</button>
                    <button onClick={downloadPDF}>Baixar em PDF</button>
                </div>
            </div>

            <div className={styles.extraContent}>
                <h3>Gerar QR Code para WhatsApp</h3>
                <p>
                    Crie facilmente um QR Code que abre diretamente uma conversa no WhatsApp.
                    Basta inserir o DDI e o número do telefone. Ideal para empresas, atendimento ao cliente,
                    vendas online e redes sociais.
                </p>

                <h3>Personalização de cores</h3>
                <p>
                    Você pode alterar as cores do QR Code (fundo e código) para combinar com sua marca.
                    Recomendamos manter um bom contraste para garantir leitura perfeita.
                </p>

                <h3>Download em PNG e PDF</h3>
                <p>
                    Baixe seu QR Code em alta qualidade no formato PNG ou pronto para impressão em PDF.
                </p>

                <h3>Palavras-chave</h3>
                <p>
                    gerador de qr code grátis, criar qr code online, qr code whatsapp, qr code personalizado,
                    qr code com logo, gerar qr code para link, criar qr code pdf, qr code png download,
                    ferramenta qr code online, qr code marketing digital, qr code para empresas
                </p>
            </div>

            <div id="BoxAfiliados" className={styles.afiliados}></div>

        </div>
    );
};

export default QrCodeGenerator;